import { Typography } from "@/components/common/Typography/Typography"
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import React from "react"

interface CollapsibleQuestionnaireListProps extends React.PropsWithChildren {
  sectionIndex: number
  sectionTitle: string
  sectionCountDisplay: React.JSX.Element
  dataTestId?: string
}

export const CollapsibleQuestionnaireList: React.FC<
  CollapsibleQuestionnaireListProps
> = ({
  sectionIndex,
  sectionTitle,
  sectionCountDisplay,
  dataTestId,
  children,
}) => {
  const wrappedChildren = React.Children.map(children, (child) => (
    <div className="border-t border-grey7">{child}</div>
  ))

  return (
    <Accordion type="single" collapsible defaultValue="item-1">
      <AccordionItem value="item-1" className="border-none">
        <AccordionTrigger
          className="py-M hover:no-underline"
          data-testid={dataTestId}
        >
          <div className="flex w-full items-center justify-between">
            <Typography
              as="p"
              variant="textM-bold"
              className="flex-1 break-all text-left"
            >
              {`${sectionIndex + 1}. ${sectionTitle}`}
            </Typography>
            <div className="flex pr-4">{sectionCountDisplay}</div>
          </div>
        </AccordionTrigger>
        <AccordionContent>{wrappedChildren}</AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
